import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { PricingDetailModal } from './PricingDetailModal';
export function PricingDetail() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section id="precios" className="bg-arena py-[56px] md:py-[80px]" data-id="element-132" data-mp="3h22x7py3m1ly">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-133" data-mp="3l0aimy3ibr3h">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-arena-dark border border-salvia/25 rounded-[12px] px-8 py-8 md:py-9 flex flex-col md:flex-row md:items-center md:justify-between gap-5 max-w-[760px] mx-auto" data-id="element-134" data-mp="379ououz74qyq">
          <p className="font-display text-[18px] md:text-[20px] font-semibold text-carbon" data-id="element-135" data-mp="2ob2s1bo16rsp">
            ¿Necesitas conocer todas las configuraciones?
          </p>
          <button onClick={() => setIsModalOpen(true)} className="inline-flex items-center justify-center gap-1.5 bg-verde text-arena font-display font-semibold text-[14px] px-6 py-3.5 rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta transition-all duration-200 flex-shrink-0" data-id="element-136" data-mp="2tc8l5allsh2r">
            Ver alcance detallado <ArrowRight size={15} data-id="element-137" data-mp="1hyjv0pur1i24" />
          </button>
        </motion.div>
      </div>

      <PricingDetailModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-138" data-mp="u9hexmfrjx9q" />
    </section>;
}